<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput
                    :options="valueInput.options"
                    :data="valueInput.data"
                  />
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6">
                  <BaseInput
                    :options="nameInput.options"
                    :data="nameInput.data"
                  />
                </CCol>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
                  <BaseSelect
                    :options="districtCodeInput.options"
                    :data="districtCodeInput.data"
                    ref="districtCodeInput"
                  ></BaseSelect>
                </CCol>
                <CCol xs="12" sm="12" md="6" lg="6" xl="6" v-if="!$hasAuthor('ROLE_WARD')">
                  <BaseSelect
                    :options="wardCodeInput.options"
                    :data="wardCodeInput.data"
                    ref="wardCodeInput"
                  ></BaseSelect>
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea
                    :options="descriptionInput.options"
                    :data="descriptionInput.data"
                    v-model="descriptionInput.data.model"
                  />
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData"
                >
                  <i class="fa fa-save"></i> Lưu lại
                </CButton>
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"
                  ><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../../base/BaseSelect2";
import BaseInput from "../../base/BaseInput";
import BaseLoading from "../../base/BaseFormLoading";
import BaseTextArea from "../../base/BaseTextArea.vue";
import { LOCATION_CODE_NAME } from '../../../constant';

export default {
  name: "ScreenStationUpdate",
  components: { BaseSelect, BaseInput, BaseLoading, BaseTextArea },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Errors",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      wardCode: { value: null },
      idField: {
        data: {
          model: that.$route.params.id,
          name: "id",
        },
      },
      valueInput: {
        options: {
          label: "Mã nhóm bảng điện tử <span class='required'>*</span>",
          placeholder: "Mã nhóm bảng điện tử",
          maxlength: 255,
          readonly: true
        },
        data: {
          name: "value",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              // let value = that.valueInput.data.model;
              // if (value === "") {
              //   this.isValid = false;
              //   this.errorMessage = "Mã nhóm bảng điện tử không được để trống";
              // } else {
              //   this.isValid = true;
              // }
              return this.isValid;
            },
          },
        },
      },
      nameInput: {
        options: {
          label: "Tên nhóm bảng điện tử <span class='required'>*</span>",
          placeholder: "Tên nhóm bảng điện tử",
          maxlength: 200,
        },
        data: {
          name: "name",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.nameInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tên nhóm bảng điện tử không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      descriptionInput: {
        options: {
          label: "Mô tả",
          placeholder: "Mô tả",
          maxlength: 2000,
          rows: 5,
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
        },
      },
      districtCodeInput:{
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Chọn Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput:{
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Chọn Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
              setTimeout(function () {
                if(that.wardCode.value){
                  that.wardCodeInput.data.model = that.wardCode.value;
                  that.wardCode.value = null;
                }
              }, 200);
            }
          },
        }
      },
    };
  },
  methods: {
    submitData: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/screen-station/update",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({
              message: that.$helper.getStringError(response.data.data),
            });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Cập nhật nhóm bảng điện tử thành công",
            });
            that.$router.go(-1);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
    // loadDataLocation: function (parentCode) {
    //   let that = this;
    //   that.loading.value = true;
    //   this.$helper.loadDataSource({
    //     loading: that.loading,
    //     dataSubmit: function () {
    //       return {
    //         parentCode: parentCode,
    //       };
    //     },
    //     url: "/common/findByParentCodeAndCode",
    //     successCallback: function (response) {
    //       if (parentCode) {
    //         that.wardCodeInput.data.items = response.data.data;
    //         if(that.wardCode.value){
    //           that.loadData();
    //           that.wardCode.value = null;
    //         }
    //       } else {
    //         that.districtCodeInput.data.items = response.data.data;
    //       }
    //       that.loading.value = false;
    //     },
    //     errorCallback: function (error) {
    //       that.$helper.handleError(that.$router, error);
    //       that.loading.value = false;
    //     },
    //   });
    // },
    loadData: function () {
      let that = this;
      that.loading.value = true;
      this.$helper.loadDataSource({
        loading: that.loading,
        isJsonContentType: false,
        dataSubmit: function () {
          return {id: that.idField.data.model}
        },
        ignoreDefaultData: true,
        url: "/screen-station/findById",
        successCallback: function (response) {
          that.wardCode.value = response.data.data.wardCode;
          that.$helper.setupDataResponse(that.$data, response.data.data);
          that.loading.value = false;
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false;
        },
      });
    },
  },
  computed: {

  },
  created() {
    this.loadData();
    // this.loadDataLocation();
  },
  mounted() {
  },
  watch: {
    // "districtCodeInput.data.model": function () {
    //   if (this.districtCodeInput.data.model) {
    //     this.loadDataLocation(this.districtCodeInput.data.model);
    //   } else {
    //     this.wardCodeInput.data.items = [];
    //   }
    // },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;       
      }
    },
  },
};
</script>
